var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFieldAbc = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 2.3 14 10",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.167
}, /*#__PURE__*/React.createElement("path", {
  d: "m1.168 12.25 1.441-3.5m0 0 .6-1.459 2.042-4.958 2.042 4.958.6 1.459m-5.284 0h5.284m1.442 3.5-1.442-3.5M8.168 2.917h4.667M9.332 5.833h3.5M10.5 8.75h2.333M11.668 11.667h1.167"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFieldAbc);
export default ForwardRef;